'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _formFieldUtils = require('../common/formFieldUtils');

var _util = require('./util');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var LicenseField = (_temp = _class = function (_Field) {
  _inherits(LicenseField, _Field);

  LicenseField.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var superState = _Field.getDerivedStateFromProps.call(this, props, state);
    var provinceDataSource = (0, _formFieldUtils.convertOptionsText)(props.provinceDataSource.options);
    var cityDataSource = (0, _formFieldUtils.convertOptionsText)(props.cityDataSource.options);
    var leftCount = 0;
    !(0, _lodash.isEmpty)(provinceDataSource) && leftCount++;
    !(0, _lodash.isEmpty)(cityDataSource) && leftCount++;

    var fieldDataValue = (superState && superState.fieldData || state.fieldData || {}).value;

    var _deconstructionValue = (0, _util.deconstructionValue)(fieldDataValue),
        province = _deconstructionValue.province,
        city = _deconstructionValue.city,
        value = _deconstructionValue.value;

    // 从fieldData中解析出省市县

    return _extends({}, superState, {
      provinceDataSource: provinceDataSource,
      cityDataSource: cityDataSource,
      leftCount: leftCount,
      province: province,
      city: city,
      value: value
    });
  };

  function LicenseField(props) {
    _classCallCheck(this, LicenseField);

    // 不动 fieldData，单独存一个value
    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _initialiseProps.call(_this);

    _this.state = _extends({}, _this.state, {
      province: '',
      city: '',
      value: ''
    });
    return _this;
  }

  LicenseField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-license'
    });
  };

  LicenseField.prototype.renderAddonBefore = function renderAddonBefore() {
    var _this2 = this;

    var _state = this.state,
        provinceDataSource = _state.provinceDataSource,
        cityDataSource = _state.cityDataSource,
        behavior = _state.behavior,
        province = _state.province,
        city = _state.city;

    var addonProps = {
      readOnly: behavior === 'READONLY',
      disabled: behavior === 'DISABLED',
      popupClassName: 'vc-license-popup',
      style: { minWidth: '80px' }
    };
    if ((0, _lodash.isEmpty)(provinceDataSource) && (0, _lodash.isEmpty)(cityDataSource)) {
      return null;
    }
    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      !(0, _lodash.isEmpty)(provinceDataSource) && _react2.default.createElement(_next.Select, _extends({}, addonProps, {
        placeholder: '\u9009\u62E9\u7701',
        dataSource: provinceDataSource,
        value: province,
        onChange: function onChange(value) {
          return _this2.handleLicenseChange(value, 'province');
        }
      })),
      !(0, _lodash.isEmpty)(cityDataSource) && _react2.default.createElement(_next.Select, _extends({}, addonProps, {
        placeholder: '\u9009\u62E9\u5E02',
        disabled: (0, _lodash.isEmpty)(province),
        dataSource: cityDataSource,
        value: city,
        onChange: function onChange(value) {
          return _this2.handleLicenseChange(value, 'city');
        }
      }))
    );
  };

  LicenseField.prototype.renderControl = function renderControl() {
    var _this3 = this;

    var value = this.state.value;

    var commonProps = this.getControlProps();

    var inputProps = _extends({}, commonProps, {
      value: value,
      onChange: function onChange(value, event, type) {
        _this3.handleLicenseChange(value, 'value', type);
      }
    });
    return _react2.default.createElement(
      _next.Input.Group,
      { addonBefore: this.renderAddonBefore() },
      _react2.default.createElement(_next.Input, inputProps)
    );
  };

  return LicenseField;
}(_vuFusionField2.default), _class.displayName = 'License', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  provinceDataSource: [],
  cityDataSource: []
}), _class.propTypes = {
  provinceDataSource: _propTypes2.default.array,
  cityDataSource: _propTypes2.default.array
}, _class.validators = {
  license: {
    valid: function valid(value, param) {
      return _util.LICENSE_REG.test(value);
    },
    defaultMessage: {
      en_US: '%s format error',
      zh_CN: '%s格式不正确'
    }
  }
}, _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['provinceDataSource', 'cityDataSource', {
  name: 'fieldData',
  formatIn: function formatIn() {
    var fieldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments[1];

    // 解析默认值
    var defaultProvince = void 0;
    var defaultCity = void 0;
    try {
      defaultProvince = (0, _lodash.get)((0, _formFieldUtils.getDefaultOptions)(props.getValue('provinceDataSource').options), '[0].value');
      defaultCity = (0, _lodash.get)((0, _formFieldUtils.getDefaultOptions)(props.getValue('cityDataSource').options), '[0].value');
    } catch (e) {
      console.error(e);
    }

    if (!(0, _lodash.isEmpty)(fieldData.value)) {
      return fieldData;
    } else {
      return _extends({}, fieldData, { value: '' + (0, _util.getStrNotNull)(defaultProvince) + (0, _util.getStrNotNull)(defaultCity) });
    }
  }
}]), _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleLicenseChange = function (current) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
    var type = arguments[2];
    var onChange = _this4.props.onChange;
    var _state2 = _this4.state,
        province = _state2.province,
        city = _state2.city,
        value = _state2.value;

    var licenseValue = '';
    if (type === 'clear') {
      licenseValue = '';
    } else {
      if (key === 'province') {
        licenseValue = '' + (0, _util.getStrNotNull)(current, province) + (0, _util.getStrNotNull)(city) + (0, _util.getStrNotNull)(value);
      } else if (key === 'city') {
        licenseValue = '' + (0, _util.getStrNotNull)(province) + (0, _util.getStrNotNull)(current, city) + (0, _util.getStrNotNull)(value);
      } else {
        licenseValue = '' + (0, _util.getStrNotNull)(province) + (0, _util.getStrNotNull)(city) + (0, _util.getStrNotNull)(current, value);
      }
    }
    if (typeof value == 'string') {
      licenseValue = licenseValue.toUpperCase();
    }
    if ((0, _lodash.isFunction)(onChange)) {
      onChange({ value: _this4.formatOut(licenseValue) });
    }
  };
}, _temp);
exports.default = LicenseField;
module.exports = exports['default'];